import getLocalString from "constants/Localization";
import { Grid } from "@mui/material";
import MDAlert from "components/MDAlert";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import { CreateCrewInput, CreateCrewMutationResult } from "generated/graphql";
import useCreateCrew from "hooks/organization/useCreateCrew";
import DashboardLayout from "layouts/DashboardLayout/DashboardLayout";
import Create from "modules/OrganizationCrews/Create";
import DashboardNavbar from "partials/DashboardNavbar/DashboardNavbar";
import Footer from "partials/Footer/Footer";
import { useCallback } from "react";
import { useNavigate } from "react-router";
import { getRoute } from "utils/routing";

export default function CrewCreatePage() {
  const [createCrew, { loading, error, getData, isSuccess }] = useCreateCrew();
  const navigate = useNavigate();

  const onSubmit = useCallback(
    async (values: CreateCrewInput) => {
      const formattedInput = {
        ...values,
        rate: Math.floor(values.rate * 100),
      };
      const result = await createCrew({ variables: { input: formattedInput } });
      const success = isSuccess(result.data);
      const data = getData(result);
      if (isSuccess) {
        navigate(getRoute("organization.crews"));
      }
      return { success, data };
    },
    [createCrew]
  );

  return (
    <DashboardLayout>
      <DashboardNavbar />
      {error && (
        <MDAlert color="error">{getLocalString("organization.create-crew-failure")}</MDAlert>
      )}
      <MDBox my={3}>
        <MDBox mb={6}>
          <Grid container spacing={3} alignItems="center">
            <Grid item xs={12} lg={6}>
              <MDTypography variant="h4" fontWeight="medium">
                Create Crew
              </MDTypography>
            </Grid>
          </Grid>
        </MDBox>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Create onSubmit={onSubmit} loading={loading} />
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}
